import { useMemo } from 'react';
import { Languages } from 'lucide-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@app/i18n/languages';

export const LanguageSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { lng = 'es' } = useParams();

  const nextLanguage: SupportedLanguage = useMemo(() => (lng === 'es' ? 'en' : 'es'), [lng]);

  const handleChangeLanguage = () => {
    const segments = location.pathname.split('/');
    segments[1] = nextLanguage;
    void navigate(`${segments.join('/')}${location.search}`, { replace: true });
  };

  return (
    <button
      className="toolbar-button"
      type="button"
      aria-label="Change language"
      title="Change language"
      onClick={handleChangeLanguage}
      disabled={!SUPPORTED_LANGUAGES.some((language) => language === lng)}
    >
      <Languages className="h-4 w-4" aria-hidden="true" />
      <span className="sr-only">{nextLanguage.toUpperCase()}</span>
    </button>
  );
};
